import { __extends } from "tslib";
import { ConflictStrategyBase } from './ConflictStrategyBase';
var IgnoreConflictStrategy = /** @class */ (function (_super) {
    __extends(IgnoreConflictStrategy, _super);
    function IgnoreConflictStrategy() {
        return _super.call(this) || this;
    }
    IgnoreConflictStrategy.prototype.resolveConflict = function (changedAsset, oldAsset, assetsDictionary, precedence) {
        // Do nothing, ignore the fact that there is a conflict.
        return;
    };
    IgnoreConflictStrategy.prototype.create = function () {
        return new IgnoreConflictStrategy();
    };
    return IgnoreConflictStrategy;
}(ConflictStrategyBase));
export { IgnoreConflictStrategy };
